<div class="fadein">
  <!-- #region IndexSegofinance -->
@if (plataformaId === 'SEGOFINANCE') {
  <div id="home-{{plataformaId | lowercase}}">
    <app-banner-portada [plataformaId]="plataformaId"></app-banner-portada>
    <app-lineas-inversion [plataformaId]="plataformaId"></app-lineas-inversion>
    <app-ahorra-invierte-rentabiliza></app-ahorra-invierte-rentabiliza>
    <app-estadisticas-plataforma [plataformaId]="plataformaId"></app-estadisticas-plataforma>
    <app-valoracion-clientes></app-valoracion-clientes>
    <app-cita-dto-inversores></app-cita-dto-inversores>
    <app-noticias-prensa [plataformaId]="plataformaId"></app-noticias-prensa>
    <app-asociaciones-index></app-asociaciones-index>
  </div>
}
<!-- #endregion -->

<!-- #region IndexCNMV -->
@if (plataformaId === 'VENTURE' || plataformaId === 'REALESTATE' || plataformaId === 'CREATIVE') {
  <div id="home-{{plataformaId | lowercase}}">
    <app-banner-portada [plataformaId]="plataformaId"></app-banner-portada>
    <app-estadisticas-plataforma [plataformaId]="plataformaId"></app-estadisticas-plataforma>
    <app-lineas-inversion [plataformaId]="plataformaId"></app-lineas-inversion>
    <app-home-casos-exito></app-home-casos-exito>
    <app-noticias-prensa [plataformaId]="plataformaId"></app-noticias-prensa>
    <section class="bg-primary-100">
      <app-contactenos [data]="ayudaDataCNMV"></app-contactenos>
    </section>
    <app-home-faqs [plataformaId]="plataformaId"></app-home-faqs>
  </div>
}
<!-- #endregion -->

<!-- #region Index FACTORING -->
@if (plataformaId == 'FACTORING') {
  <div id="home-{{plataformaId | lowercase}}">
    <app-banner-portada [plataformaId]="plataformaId"></app-banner-portada>
    <section class="mb-5">
      <app-estadisticas-plataforma [plataformaId]="plataformaId"></app-estadisticas-plataforma>
    </section>
    <section class="mb-5">
      <app-home-factoring></app-home-factoring>
    </section>
    <section>
      <app-tipos-operaciones></app-tipos-operaciones>
    </section>
    <app-ventajas [isCFFactoring]="false" [ventajasData]="ventajasData" [sectionVentajaData]="sectionVentajaData"></app-ventajas>
    <section class="bg-primary-100">
      <app-contactenos [data]="ayudaDataFactoring"></app-contactenos>
    </section>
    <section>
      <app-home-faqs [plataformaId]="plataformaId"></app-home-faqs>
    </section>
  </div>
}
<!-- #endregion -->

<!-- #region Index FUNDS -->
@if (plataformaId == 'FUNDS') {
  <div id="home-{{plataformaId | lowercase}}">
    <app-banner-portada [plataformaId]="plataformaId"></app-banner-portada>
    <section class="mb-5">
      <app-estadisticas-plataforma [plataformaId]="plataformaId"></app-estadisticas-plataforma>
    </section>
    <section class="mb-5">
      <app-home-funds></app-home-funds>
    </section>
    <section class="bg-primary-100">
      <app-codigo-promocional [textColorClass]="'primary-900'"></app-codigo-promocional>
    </section>
    <section>
      <app-porque-my-investor></app-porque-my-investor>
    </section>
    <section class="bg-primary-100">
      <app-contactenos [data]="ayudaDataFunds"></app-contactenos>
    </section>
    <section>
      <app-home-faqs [plataformaId]="plataformaId"></app-home-faqs>
    </section>
  </div>
}
<!-- #endregion -->
</div>
